import { render } from "./sharewell_footer.vue?vue&type=template&id=21affbc2"
import script from "./sharewell_footer.vue?vue&type=script&lang=js"
export * from "./sharewell_footer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__